import apiConfig from '../../../apiConfig';

export type AvailableSlotByStaff = {
  time: string;
  available: boolean;
};

export const fetchAvailableTimesByStaff = async (params: {
  storeId: number;
  staffId: number;
  date: string;
  durationMinutes: number;
  serviceIds?: number[];
  excludeReservationId?: number;
}): Promise<AvailableSlotByStaff[]> => {
  const res = await fetch(`${apiConfig.baseURL}/api/customer-app/reservation/by-staff/available-times`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      store_id: params.storeId,
      staff_id: params.staffId,
      date: params.date,
      duration_minutes: params.durationMinutes,
      service_ids: params.serviceIds,
      exclude_reservation_id: params.excludeReservationId ?? null,
    }),
  });

  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data?.error || 'Failed to fetch available times');
  }

  const data = await res.json();
  return Array.isArray(data?.slots) ? data.slots : [];
};
